module.exports = __webpack_public_path__ + "media/images/video-1b615f3ae5dd1dda10e316e280dcb03c.svg";